module.exports = __webpack_public_path__ + "img/logo-discontract-multi.0fd1b66.svg";